module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_1-933d31d2989a30a35eb17288bae3b5c5.jpg";